import crudActions from '../../crud/actions'

const actions = crudActions('SETTINGS_LISTS_FOODS_')

export default actions
